import * as React from "react";
import DatePicker from "react-datepicker";
import { getCurrencyByString } from "../../../utils/currency";
import { fullName } from "../../../helperComponents";

var PolizaInfo = function PolizaInfo(props) {
  var _poliza$company, _companies$find, _poliza$broker_inform, _poliza$broker_inform2, _poliza$broker_inform3, _poliza$broker_inform4, _poliza$broker_inform5;

  var poliza = props.poliza,
      companies = props.companies;
  var currency = getCurrencyByString(poliza.currency);
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "N Poliza"), poliza.code), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Compa\xF1\xEDa"), ((_poliza$company = poliza.company) === null || _poliza$company === void 0 ? void 0 : _poliza$company.name) || "Sin compañia", companies && ((_companies$find = companies.find(function (company) {
    return company.id === poliza.company_id;
  })) === null || _companies$find === void 0 ? void 0 : _companies$find.name)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Ramo"), poliza.ramo || "Sin ramo")), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Contratante"), fullName(poliza.contratante) || "Sin contratante"), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Beneficiario"), fullName(poliza.beneficiario) || "Sin beneficiario"), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Item Asegurado"), (poliza === null || poliza === void 0 ? void 0 : poliza.materia_asegurada_formatted) || "Sin materia asegurada")), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Inicio vigencia"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    selected: poliza.start_date,
    disabled: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Fin vigencia"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    selected: poliza.finish_date,
    disabled: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Prima Neta Afecta"), currency, " ", ((_poliza$broker_inform = poliza.broker_information) === null || _poliza$broker_inform === void 0 ? void 0 : _poliza$broker_inform.affects_net_bonus) || "-"), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Prima Neta Exenta"), currency, " ", ((_poliza$broker_inform2 = poliza.broker_information) === null || _poliza$broker_inform2 === void 0 ? void 0 : _poliza$broker_inform2.exempt_net_bonus) || "-"), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Prima Neta"), currency, " ", ((_poliza$broker_inform3 = poliza.broker_information) === null || _poliza$broker_inform3 === void 0 ? void 0 : _poliza$broker_inform3.net_bonus) || "-"), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "IVA"), currency, " ", ((_poliza$broker_inform4 = poliza.broker_information) === null || _poliza$broker_inform4 === void 0 ? void 0 : _poliza$broker_inform4.iva) || "-"), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Prima Total"), currency, " ", ((_poliza$broker_inform5 = poliza.broker_information) === null || _poliza$broker_inform5 === void 0 ? void 0 : _poliza$broker_inform5.total_bonus) || "-"), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Monto Asegurado"), currency, " ", poliza.total_asegurado_amount || "-")));
};

export default PolizaInfo;